export default __webpack_public_path__ + "static/media/mentalic.364668c2.png";